import React from "react";

const Whatsapp = ({ ...rest }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g clipPath="url(#clip0_4733_12354)">
                <path
                    d="M14.223 0.953865C8.15858 -0.227419 2.31368 3.62343 1.04293 9.62031C0.482972 12.2613 0.865666 14.7861 2.13231 17.1738C2.24501 17.3868 2.26908 17.5747 2.20392 17.8076C1.74316 19.4505 1.29532 21.097 0.842188 22.7423C0.816362 22.8356 0.778797 22.9249 0.746515 23.0166C0.751797 23.1339 0.687232 23.3037 0.922014 23.2494C2.3624 22.8672 3.8022 22.4843 5.24259 22.102C5.61002 22.0045 5.98098 21.9199 6.3443 21.8102C6.57615 21.7401 6.77337 21.7722 6.98702 21.8814C8.21434 22.51 9.52149 22.8917 10.892 23.0224C13.6583 23.2862 16.2069 22.6454 18.4749 21.0439C21.1502 19.1546 22.7503 16.5709 23.1658 13.3346C23.9447 7.26767 19.8267 2.04469 14.223 0.953865ZM13.6812 20.9703C11.4191 21.3637 9.29962 20.9762 7.31923 19.8334C7.0733 19.6916 6.8573 19.6496 6.5785 19.7266C5.66813 19.9793 4.75131 20.2069 3.83566 20.441C3.53572 20.5174 3.50051 20.4818 3.58151 20.1859C3.82216 19.307 4.05929 18.4274 4.3152 17.5525C4.39209 17.2893 4.36861 17.0798 4.216 16.8452C3.44533 15.6616 2.96931 14.3606 2.8302 12.9611C2.52205 9.85202 3.51577 7.20405 5.83013 5.08719C7.57515 3.49094 9.66764 2.72229 12.0378 2.7077C16.6043 2.65517 20.4705 6.09572 21.1766 10.4234C21.9796 15.347 18.6175 20.1112 13.6806 20.9703H13.6812Z"
                    fill="#059669"
                />
                <path
                    d="M17.5052 14.3821C16.7416 13.9928 15.9762 13.6082 15.1832 13.2802C14.9185 13.1705 14.7183 13.2423 14.5458 13.467C14.2852 13.8055 14.0075 14.1311 13.7387 14.4638C13.5761 14.6652 13.3889 14.706 13.1435 14.6074C11.53 13.9596 10.2939 12.8804 9.39232 11.4073C9.23971 11.1581 9.26202 10.9702 9.46334 10.7618C9.7128 10.5038 9.95345 10.2354 10.1125 9.90619C10.1923 9.74044 10.2323 9.56535 10.1636 9.39959C9.8431 8.61927 9.51499 7.84128 9.1775 7.06796C9.08652 6.85843 8.91219 6.74112 8.6645 6.75163C8.52891 6.75688 8.39215 6.73645 8.25598 6.7312C7.91143 6.71836 7.59741 6.79598 7.34326 7.04344C6.48513 7.8798 6.14881 8.88541 6.37537 10.0626C6.56555 11.0513 7.1032 11.8696 7.69074 12.6639C9.22739 14.7422 11.1256 16.332 13.6607 17.075C14.0938 17.2023 14.5258 17.3091 15.0159 17.2717C15.1181 17.2717 15.2572 17.2886 15.3904 17.2688C16.5925 17.0919 17.8004 16.3332 17.7441 14.8146C17.7371 14.622 17.6789 14.4714 17.5046 14.3827L17.5052 14.3821Z"
                    fill="#059669"
                />
            </g>
            <defs>
                <clipPath id="clip0_4733_12354">
                    <rect
                        width="22.5185"
                        height="22.5185"
                        fill="white"
                        transform="translate(0.740234 0.740723)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Whatsapp;
